import { BrowserRouter } from 'react-router-dom'
import ScrollToTop from './components/ScrollToTop'
import { AppRoutes } from './router'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App